export default __webpack_public_path__ + "static/media/second.c398ab05.jpg";